// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs[data-v-cf269316]{flex:1 1 auto;display:flex;flex-direction:row;justify-content:space-between}.tabs__left[data-v-cf269316],.tabs__right[data-v-cf269316]{display:flex;flex-direction:row;align-items:center;justify-content:flex-end;box-sizing:border-box}.tabs__tab[data-v-cf269316]{display:flex;align-items:center;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
